import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsTags } from "@foodpilot/foods";

type InfoRowProps = {
    label: string;
    value: string;
    isLast?: boolean;
    required?: boolean;
};

export const InfoRow = ({ label, value, isLast, required }: InfoRowProps) => {
    const { t } = useTranslation();
    const hasValue = typeof value === "string" && value.trim().length > 0;

    return (
        <Stack
            sx={(theme) => ({
                minHeight: "64px",
                borderBottom: isLast ? "none" : "1px solid #E0DEDD",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                gap: { xs: theme.spacing(2), md: theme.spacing(0) },
                py: { xs: theme.spacing(2), md: theme.spacing(2) },
                px: theme.spacing(4),
            })}
        >
            <Typography
                variant="h5"
                sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    width: "321px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {label}
                {required && (
                    <Typography component="span" sx={{ color: "error.main", ml: 0.5 }}>
                        *
                    </Typography>
                )}
            </Typography>
            <Box sx={{ flex: 1 }}>
                {hasValue ?
                    <Typography variant="body-medium" color="text.secondary">
                        {value}
                    </Typography>
                :   <FoodsTags
                        variant={required ? "tags-red" : "tags-grey"}
                        label={t("companySettings.general.not_provided", "Information not provided")}
                        sx={{
                            height: "unset",
                            textAlign: "left",
                        }}
                    />
                }
            </Box>
        </Stack>
    );
};
